import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Monitoramento")
], -1)
const _hoisted_3 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_4 = { class: "table-responsive p-0" }
const _hoisted_5 = { class: "table align-items-center mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Motorista"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs" }, "-"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "-")
  ])
], -1)
const _hoisted_7 = { class: "align-middle text-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs font-weight-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "d-flex flex-column text-xxs badge badge-sm bg-gradient-danger"
}
const _hoisted_10 = { class: "text-secondary text-xs opacity-7" }
const _hoisted_11 = { class: "text-sm justify-content-center w-5" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  class: "align-middle text-center monitoramento",
  style: {"display":"flex"}
}
const _hoisted_15 = { class: "stepper" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "fas fa-check"
}
const _hoisted_20 = {
  key: 2,
  class: "fas fa-times"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rotas, (rota) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_7, [
                  (rota.operador)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(rota.operador.nome_completo), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "sem motorista")),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(rota.Veiculo.marca + " " + rota.Veiculo.modelo), 1),
                  _createElementVNode("div", null, _toDisplayString($options.fDate(rota.previsao_inicio)) + "-" + _toDisplayString($options.fDate(rota.previsao_fim)), 1)
                ]),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "text-xs font-weight-bold",
                    innerHTML: $setup.calculaConclusao(rota.Pedidos)
                  }, null, 8, _hoisted_12),
                  _createElementVNode("span", {
                    class: "text-xs font-weight-bold",
                    innerHTML: $setup.calculaAtraso(rota)
                  }, null, 8, _hoisted_13)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["step icon", [ $setup.getRotaClassByStatus(rota.status_entrega)]])
                        }, _hoisted_17, 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(['step', $setup.getClassByStatus(pedido.status_entrega)])
                          }, [
                            (pedido.status_entrega > 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass([$setup.checkAtrasado(pedido, rota)])
                                }, [
                                  (pedido.status_entrega === 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(index+1), 1))
                                    : _createCommentVNode("", true),
                                  (pedido.status_entrega === 2)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                                    : _createCommentVNode("", true),
                                  (pedido.status_entrega === 3)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                    : _createCommentVNode("", true)
                                ], 2))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass([$setup.checkAtrasado(pedido, rota)])
                                }, _toDisplayString(index+1), 3))
                          ], 2))
                        }), 128)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["step icon", rota.finalizado?'pedido-concluido':'pedido-desativado'])
                        }, _hoisted_22, 2)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}